<template>
  <div class="radiogroup">
    <p v-if="small" class="form__text form__text_smspace">{{title}}</p>
    <h3 v-if="!small" class="form__title" :id="$id('rgtitle')">{{title}}</h3>
    <div class="radiogroup__content" :class="{'radiogroup__content_grid':grid, 'radiogroup__content_gridstay':gridstay}" role="radiogroup" :aria-labelledby="$id('rgtitle')">
      <RadioInput :disabled="disabled" v-for="v in values" :key="v" v-model="val"  :name="name" :text="v" :inputvalue="v" :required="required"/>
    </div>
  </div>
</template>

<script>
import RadioInput from './RadioInput.vue'
export default {
  components: {RadioInput},
  props: {
    grid: {type: Boolean, required: false, default: false},
    gridstay: {type: Boolean, required: false, default: false},
    title: {type: String, required: true},
    value: {type: String},
    values: {type: Array, required: true},
    name: {type: String, required: true},
    required: {type: Boolean},
    attrmode: {type: Boolean, default: false},
    small: {type: Boolean, default: false},
    disabled: { type: Boolean, default: false },
  },
  computed: {
    val:{
      get(){
        return this.value
      },
      set(v){
        this.$emit('input', v)
      },
    }
  },
  watch: {
    value(val, old){
      if (this.attrmode)
        this.$el.setAttribute('data-value', val)
      if (val != old)
        this.$emit('input', val)
    }
  }

}
</script>

<style lang="sass" scoped>
.radiogroup
  &__content
    padding-top: var(--basespace)
    &_grid
      display: grid
      grid-gap: 32px
      gap: 32px
      grid-template-columns: 180px 180px
      justify-content: start
      align-content: start
      @include for-nano
        &:not(.radiogroup__content_gridstay)
          grid-template-columns: 1fr
        &.radiogroup__content_gridstay
          grid-template-columns: 1fr 1fr
          gap: 0
          grid-gap: 0
    &:not(&_grid) >*:not(:last-child)
      margin-bottom: 32px
    label
      display: flex

</style>